import PropTypes from 'prop-types';

export const MenuItemsTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func, PropTypes.object]).isRequired,
});
